/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateDestroyByEmail } from '../../axios/candidateDestroyByEmail'
import type {
	CandidateDestroyByEmailError,
	CandidateDestroyByEmailQueryParams,
	CandidateDestroyByEmailResponse,
} from '../../types/CandidateDestroyByEmail'

export const candidateDestroyByEmailMutationKey = () => [{ url: '/candidates/by-email' }] as const

export type CandidateDestroyByEmailMutationKey = ReturnType<typeof candidateDestroyByEmailMutationKey>

export type CandidateDestroyByEmailVariables = {
	params: CandidateDestroyByEmailQueryParams
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::destroyByEmail */
export function useCandidateDestroyByEmail<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateDestroyByEmailResponse,
		AxiosError<CandidateDestroyByEmailError>,
		CandidateDestroyByEmailVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateDestroyByEmailMutationKey(),
		mutationFn: ({ params }: CandidateDestroyByEmailVariables) =>
			candidateDestroyByEmail(params, config).then(res => res.data),
		...options,
	})
}
